import { actionCreator } from './../actions/actions';
export const SetFilterLocationAction = 'SetFilterLocationAction';
export const createSetFilterLocationAction = actionCreator(SetFilterLocationAction);
export const SetContactDetailsAction = 'SetContactDetailsAction';
export const createSetContactDetailsAction = actionCreator(SetContactDetailsAction);
